import { render, staticRenderFns } from "./role-assignments.component.vue?vue&type=template&id=2e19e2f4&scoped=true"
import script from "./role-assignments.component.vue?vue&type=script&lang=ts"
export * from "./role-assignments.component.vue?vue&type=script&lang=ts"
import style0 from "./role-assignments.component.vue?vue&type=style&index=0&id=2e19e2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e19e2f4",
  null
  
)

export default component.exports